export enum AdditionalDataTypeEnum
{
    NUMBER = 'NUMBER',
    TEXT = 'TEXT',
    DATE = 'DATE',
    BOOLEAN = 'BOOLEAN'
}